import React, { useState, useEffect } from "react";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../firebase";
import Showstu from "./Showstu";
import CompanySelected from "./CompanySelected";
import JobDesc from "./JobDesc";
import { Link } from "react-router-dom";
// import { CSVLink } from "react-csv";
import ReactHtmlTableToExcel from "react-html-table-to-excel";
import "./tnp.css";
export default function Acceptedstu() {
  const [joblist, setJoblist] = useState([]);
  const [classa,setclassa] = useState("");
  const [click,setclick] = useState(true);
  const [department,setdepart] = useState("");
  const [clicked,setclicked] = useState(true);

  const ref = collection(db, "selected");
  
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  }, []);
  console.log(joblist);
  const options = [
    {
      label: "",
      value: "",
    },
    {
      label: "BE-1",
      value: "BE-1",
    },
    {
      label: "BE-2",
      value: "BE-2",
    },
    {
      label: "BE-3",
      value: "BE-3",
    },{
      label: "BE-4",
      value: "BE-4",
    },
    {
      label: "BE-5",
      value: "BE-5",
    },{
      label: "BE-6",
      value: "BE-6",
    },{
      label: "BE-7",
      value: "BE-7",
    },{
      label: "BE-8",
      value: "BE-8",
    },{
      label: "BE-9",
      value: "BE-9",
    },{
      label: "BE-10",
      value: "BE-10",
    },{
      label: "BE-11",
      value: "BE-11",
    },
  ];
  const departs = [
    {
      label: "",
      value: "",
    },
    {
      label: "CS",
      value: "CS",
    },
    {
      label: "IT",
      value: "IT",
    },
    {
      label: "ENTC",
      value: "ENTC",
    }
  ];

  
  return (
    <>
      <div className="container d-flex align-items-center justify-content-between ">
        <h1 className="logo titletnp">
          <p>
            BACTH 2021-22 PLACEMENT REPORT<span></span>
          </p>
        </h1>
        <div className="Info-btn m-3">
          {/* <button className="btn w-30 btn-submit pr" disabled={click} onClick={()=>navigate("/sortedbyclass")}>Sort by Class</button> */}
          <Link className="btn w-30 btn-submit pr" to="/sortedbyclass" disabled={click} state={{ classes: classa }}>Sort By Class</Link>
          {/* <p> */}
              <label className="labelinp m-2">Class</label>
            <select className="form-group w-100 p-2 inp" name="classa" value={classa} onChange={(e)=>(setclassa(e.target.value),setclick(false))}>
            {options.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </select>
         
            {/* </p> */}
        </div>
         
        <div className="Info-btn m-3">
          {/* <button className="btn w-30 btn-submit pr" disabled={click} onClick={()=>navigate("/sortedbyclass")}>Sort by Class</button> */}
          <Link className="btn w-30 btn-submit pr" to="/sortedbydepart" disabled={clicked} state={{ departments: department }}>Sort By Department</Link>
          {/* <p> */}
              <label className="labelinp m-2">Department</label>
            <select className="form-group w-75 p-2 inp" name="department" value={department} onChange={(e)=>(setdepart(e.target.value),setclicked(false))}>
            {departs.map((option) => (
              <option value={option.value}>{option.label}</option>
            ))}
          </select>
        
        </div>
  
        <div className="Info-btn">
        <ReactHtmlTableToExcel
          className="btn w-30 btn-submit pr"
          table="stuTable"
          filename="Excel file"
          sheet="sheet"
          buttonText="Export to excel"
        />
      </div>
      </div>
      
      {/* <button className="tnpbutton">
        Click here to get the report in Excel Sheet
      </button> */}
      <table className="tnptable" id="stuTable">
        <thead>
          <tr>
  
            <th>Student name</th>
            <th>Student Email</th>
            <th>Student ID</th>
            <th>Class</th>
            <th>Department</th>
            <th>Roll no.</th>
            <th>Placed in</th>
            <th>Postion</th>
            <th>Package</th>
          </tr>
        </thead>
        {joblist.map((post, i) => {
          return (
            <>
              {post.position.map((val, j) => {
                return (
                  <>
                    <tbody>
                      <tr>
                        <Showstu stuid={val.stuid} />
                        <CompanySelected cid={val.cid} />
                        <JobDesc postid={val.postid} cid={val.cid} />
                      </tr>
                    </tbody>
                  </>
                );
              })}
            </>
          );
        })}
      </table>
     
      {/* <CSVLink {...CSVReport}>Export to CSV</CSVLink> */}
    </>
  );
}
